import {
  SanityFooter,
  SanityLink,
  SanityLinkSection,
  SanityLinkSubsection,
} from '../../types/generated/graphql-types'
import { FooterProps } from '../components/Footer/Footer'
import { LinkSection, LinkSectionSubitem } from '../types/LinkSection'
import { notEmpty, validBlock } from '../utilities/filters'
import { isNullOrWhiteSpace } from '../utilities/string'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'
import { mapSanitySignupFormToSignupFormBlockProps } from './SignupFormMapper'

export const sanityFooterToFooterProps = (footer: SanityFooter): FooterProps => ({
  copyrightInfo: footer.copyrightInfo ?? '',
  disclosure: footer._rawDisclosureText?.filter(validBlock) ?? undefined,
  items: footer.linkSections?.filter(notEmpty).map(sanityLinkSectionToLinkSection) ?? [],
  signupFormProps: footer.signupForm
    ? mapSanitySignupFormToSignupFormBlockProps(footer.signupForm)
    : undefined,
  tagLine: footer.tagLine ?? '',
})

export const sanityLinkSectionToLinkSection = (
  section: SanityLinkSection
): LinkSection => ({
  title: !isNullOrWhiteSpace(section.title)
    ? section.title
    : section.pageReference?.page?.title ?? '',
  url: section.pageReference?.page?.path ?? '',
  hideSubItemsInMobile: !!section.hideSubitemsInMobile,
  subitems: section.subitems?.filter(notEmpty).map(subitemToLinkSectionSubitem) ?? [],
})

const subitemToLinkSectionSubitem = (
  subitem: SanityLink | SanityLinkSubsection
): LinkSectionSubitem => {
  if ('subitems' in subitem) {
    const subsection = subitem as SanityLinkSubsection
    return {
      title: subsection.title ?? '',
      links:
        subsection.subitems
          ?.filter(notEmpty)
          .map(item => mapSanityLinkToInternalExternalLink(item)) ?? [],
    }
  } else {
    return mapSanityLinkToInternalExternalLink(subitem)
  }
}
